
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import DatePicker from "react-datepicker";
import { Button } from 'react-bootstrap';
import './ResultPage.css';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';
import DataGrid from './DataGrid';
import MobileGrid from './MobileGrid';
import {buildGetWebformRoutings,buildGetWebformRoutingsOrderNum,buildgetVehicles,buildUpdateRoutingPlateRQ,buildInsertRoutingPlateRQ} from './XmlBuildFunctions'  
import {formatToYYYYMMDD} from './DateFunctions' 
import SearchableVehicleSelect from './SearchableVehicleSelect'
import axios from 'axios'; 

const ResultPage = () => {
    const [selectedDatefrom, setSelectedDateFrom] = useState(new Date());
    const [selectedDateto, setSelectedDateTo] = useState(new Date());
    const [rowData, setRowData] = useState([]);
    const [vehicleData, setvehicleData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false); 
    const [isDateSearch, setisDateSearch] = useState(true);
    const [modalrooid, setroutid] = useState(-1); 
    const [vehfilterval, setvehfilterval] = useState(""); 
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false); 
    const datesearch=()=>{  
        document.getElementById('searchbydate').classList.add('menuitem_active');
        document.getElementById('searchbyordernum').classList.remove('menuitem_active');
        setisDateSearch(true);
     } 
    const ordernumsearch=()=>{ 
        document.getElementById('searchbyordernum').classList.add('menuitem_active');
        document.getElementById('searchbydate').classList.remove('menuitem_active');
        setisDateSearch(false); 
    }


const SimpleModal = ({ isShowing, children, onClose }) => {
if (!isShowing) {
    return null;
} 
return (
    <div className="modal-backdrop">
    <div className="modal-content">
        <div className="modal-header"> 
        <button onClick={onClose} aria-label="Close Modal">
            &times;
        </button>
        </div> 
        {children}
    </div>
    </div>
);
};

const fetchInitialData = (goclik) => {
    
    if(localStorage.getItem('isLoggedIn')===null){
        navigate('/');
    }

    setIsLoading(true); 
    if(window.config.isXMLAPI){
            const xhr = new XMLHttpRequest();
            const url = window.config.API_URL_BO;

            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Type', 'text/xml');
            
            xhr.onload = function () {
                setIsLoading(false); 
                if (xhr.status >= 200 && xhr.status < 300) {
                    try { 
                        const xmlString = xhr.responseText; 
                        const parser = new DOMParser();
                        const xmlDoc = parser.parseFromString(xmlString, 'text/xml');  
                        const allvehicleData = []; 
                        const itemElements = xmlDoc.getElementsByTagName('UserPlate'); 
                        allvehicleData.push({id:"-2",name: ""});
                        allvehicleData.push({id:"-1",name:"I don't see my Vehicle"});
                        for (let i = 0; i < itemElements.length; i++) {
                            const item = itemElements[i]; 
                            const PlateId = item.getAttribute('PlateId');  
                            const PlateCode = item.getAttribute('PlateCode');   
                            allvehicleData.push({id:PlateId, name:PlateCode}); 
                        } 
                        
                        if (allvehicleData.length > 0){  
                            setvehicleData(allvehicleData);
                        }

                        if (goclik){
                            goclicked();
                        }
                    } catch (e) {
                        console.error("Error parsing initial XML:", e);
                    }
                } else {
                    console.error(`Error fetching initial data: ${xhr.status}`);
                }
            };

            xhr.onerror = () => {
                setIsLoading(false);
                console.error('Network error during initial fetch.');
            }; 
            xhr.send(buildgetVehicles());
    }else{
          try {  
                axios.get(window.config.API_URL_BO+"Assignment/Vehicles/" +localStorage.getItem('AccountID') +"/"+ localStorage.getItem('isAdmin') , { 
                        })
                        .then(response => { 
                           if (response.status === 200) { 

                                const allvehicleData = []; 
                                allvehicleData.push({id:"-2",name: ""});
                                allvehicleData.push({id:"-1",name:"I don't see my Vehicle"});
                                response.data.forEach((item) => {
                                    allvehicleData.push({id:item.mac_id, name:item.mac_nummac_st});   
                                });
                                if (allvehicleData.length > 0){  
                                    setvehicleData(allvehicleData);
                                }
                                if (goclik){
                                    goclicked();
                                }
                           }else{
                                console.error('Request failed error status:', response.status);
                           }
                           setIsLoading(false);
                        })
                        .catch(error => {
                        console.error('Request failed:', error);
                        setIsLoading(false);
                        });  
                } catch (err) {
                     console.error("API Polling Error:", err); 
                     setIsLoading(false);
                } finally {  
                }
    }
    
};
  
const savevehicle=()=>{ 
    
    if(localStorage.getItem('isLoggedIn')===null){
        navigate('/');
    }

    closeModal();

    if(window.config.isXMLAPI){
        const xhr = new XMLHttpRequest();
        const url = window.config.API_URL_BO;
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'text/xml');
        
        xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                try { 
                    const xmlString = xhr.responseText; 
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(xmlString, 'text/xml');  
                    const itemElements = xmlDoc.getElementsByTagName('Status'); 
                    for (let i = 0; i < itemElements.length; i++) {
                        const status = itemElements[0].getAttribute('Status'); 
                    } 
                    fetchInitialData(true);
                } catch (e) { 
                     alert("ERROR WHILE UPDATING");
                     goclicked();
                }
            } else { 
                 alert("ERROR WHILE UPDATING");
                 goclicked();
            } 
        };

        xhr.onerror = () => {  ;
            alert("ERROR WHILE UPDATING");
            goclicked();
        }; 
        xhr.send(buildInsertRoutingPlateRQ(modalrooid,document.getElementById("modalvehicle").value)); 
    }else{
            try {   
                  axios.post(window.config.API_URL_BO+"Assignment/InsertRoutingVehicle/" +modalrooid+"/"+document.getElementById("modalvehicle").value+"/"+localStorage.getItem('AccountID') +"/"+ localStorage.getItem('isAdmin') , { 
                        })
                        .then(response => { 
                           if (response.status === 200) { 
                                fetchInitialData(true);
                           }else{
                                alert("ERROR WHILE UPDATING");
                                goclicked();
                           } 
                        })
                        .catch(error => {
                                alert("ERROR WHILE UPDATING");
                                goclicked();
                        });  
                } catch (err) {
                                alert("ERROR WHILE UPDATING");
                                goclicked();
                } finally {  
                }
    }
}

const goclicked=()=>{ 
    
    if(localStorage.getItem('isLoggedIn')===null){
        navigate('/');
    }
     
    setRowData([]);
    if (isLoading) return;
    setIsLoading(true);
    if(window.config.isXMLAPI){
                                const xhr = new XMLHttpRequest();
                                const url = window.config.API_URL_BO;
                                xhr.open('POST', url, true);  
                                xhr.setRequestHeader('Content-Type', 'text/xml');
                                xhr.onload = function () { 
                                if (xhr.status >= 200 && xhr.status < 300) { 
                                    const xmlString = xhr.responseText;
                                    const parser = new DOMParser();
                                    const xmlDoc = parser.parseFromString(xmlString, 'text/xml');  
                                    const allRoutingsData = []; 
                                    const itemElements = xmlDoc.getElementsByTagName('Routing'); 
                                    for (let i = 0; i < itemElements.length; i++) {
                                        const item = itemElements[i];  
                                        allRoutingsData.push({
                                            OrderNum: item.getAttribute('OrderNum'),
                                            Origin: item.getAttribute('Origin'),
                                            Destination: item.getAttribute('Destination'),
                                            Route: item.getAttribute('Route'),
                                            PickUpTime: item.getAttribute('PickUpTime'),
                                            PAX: item.getAttribute('PAX'),
                                            TransferType: item.getAttribute('TransferType'),
                                            Comments: item.getAttribute('Comments'),
                                            Vehicle: item.getAttribute('Vehicle'),
                                            Driver: item.getAttribute('Driver'),
                                            ArrivalFlight: item.getAttribute('ArrivalFlight'),
                                            DepartureFlight: item.getAttribute('DepartureFlight'),
                                            DepartureTime: item.getAttribute('DepartureTime'),
                                            TourOperator: item.getAttribute('TourOperator'),
                                            Datefrom: item.getAttribute('Datefrom')
                                        });
                                        
                                    } 
                                    
                                    if (allRoutingsData.length > 0){
                                        setRowData(allRoutingsData);
                                    }
                                    setIsLoading(false);
                                } else { 
                                    setIsLoading(false);
                                }
                            }
                            if (isDateSearch){
                                xhr.send(buildGetWebformRoutings(selectedDatefrom,selectedDateto,vehfilterval,document.getElementById("flightselectid").value));  
                            }else{
                                xhr.send(buildGetWebformRoutingsOrderNum(document.getElementById("ordernumfilter").value));
                            }
            }else{
                    try {    
                            let axiosurl ="";
                            if (isDateSearch){
                                let vehiclec = -1; 
                                if (vehfilterval>0){
                                    vehiclec=vehfilterval;
                                }

                                let flighnum = -1;
                                if (document.getElementById("flightselectid").value.length > 0){
                                    flighnum=document.getElementById("flightselectid").value;
                                } 
                                axiosurl = window.config.API_URL_BO+"Assignment/Routings/" +localStorage.getItem('AccountID') +"/"+ localStorage.getItem('isAdmin') +"/"+formatToYYYYMMDD(selectedDatefrom)+"/"+formatToYYYYMMDD(selectedDateto)+"/"+vehiclec+"/"+flighnum;
                            }else{
                                axiosurl = window.config.API_URL_BO+"Assignment/RoutingsOrderNum/" +localStorage.getItem('AccountID') +"/"+ localStorage.getItem('isAdmin') +"/"+document.getElementById("ordernumfilter").value;
                            }
                            
                            axios.get(axiosurl, { 
                            })
                            .then(response => { 
                            if (response.status === 200) { 
                                    const allRoutingsData = [];  
                                        response.data.forEach((item) => {
                                             
                                            allRoutingsData.push({OrderNum:item.OrderNum, Origin:item.Origin,Destination:item.Destination,Route:item.Ipokatigoria,
                                            PickUpTime:item.FirstArrDepTime,PAX:item.NumOfPersons,TransferType:item.TransferType,Comments:item.Comments,Vehicle:item.Vehicle,
                                            Driver:item.Driver,ArrivalFlight:item.ArrivalFlight,DepartureFlight:item.DepartureFlight,DepartureTime:item.DepartureTime,TourOperator:item.TourOperator,Datefrom:item.DateFrom
                                        });   
                                    });
                                    if (allRoutingsData.length > 0){   
                                        setRowData(allRoutingsData);
                                    }
                                    setIsLoading(false); 
                            }else{
                                    console.error('Request failed error status:', response.status);
                                    setIsLoading(false);
                            }
                            })
                            .catch(error => {
                            console.error('Request failed:', error);
                            setIsLoading(false);
                            });  
                    } catch (err) {
                        console.error("API Polling Error:", err); 
                        setIsLoading(false);
                    } finally {  
                    }
            }
};
 
const setdatetodate=(date)=>{
        setSelectedDateTo(date);
}

const vehiclechangedapi=(oldValue,newValue,rooid)=>{ 

    if(localStorage.getItem('isLoggedIn')===null){
        navigate('/');
    }

    if(window.config.isXMLAPI){ 
        const xhr = new XMLHttpRequest();
        const url = window.config.API_URL_BO;

        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'text/xml');
        
        xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                try { 
                    const xmlString = xhr.responseText; 
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(xmlString, 'text/xml');  
                    const itemElements = xmlDoc.getElementsByTagName('Status'); 
                    for (let i = 0; i < itemElements.length; i++) {
                        const status = itemElements[0].getAttribute('Status'); 
                    } 
                } catch (e) { 
                    alert("ERROR WHILE UPDATING");
                    goclicked();
                }
            } else { 
                alert("ERROR WHILE UPDATING");
                goclicked();
            } 
        };

        xhr.onerror = () => {  ;
            alert("ERROR WHILE UPDATING");
            goclicked();
        }; 
        xhr.send(buildUpdateRoutingPlateRQ(rooid,newValue));
    }else{
            try {  
                 
                  axios.post(window.config.API_URL_BO+"Assignment/UpdateRoutingVehicle/" +rooid+"/"+newValue , { 
                        })
                        .then(response => { 
                           if (response.status === 200) { 
 
                           }else{
                                alert("ERROR WHILE UPDATING");
                                goclicked();
                           } 
                        })
                        .catch(error => {
                                alert("ERROR WHILE UPDATING");
                                goclicked();
                        });  
                } catch (err) {
                                alert("ERROR WHILE UPDATING");
                                goclicked();
                } finally {  
                }
    }

}
  
const vehiclechanged= (rooid,oldValue,newValue)=>{    
    setroutid(-1);  
     if (newValue==="-1"){
         setroutid(rooid);
         openModal();
     }else{
         vehiclechangedapi(oldValue,newValue,rooid);
     } 
}

const mobileBreakpoint = 768; 
const [isMobile, setIsMobile] = useState(window.innerWidth < mobileBreakpoint);
  
useEffect(() => {
    fetchInitialData(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < mobileBreakpoint);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
}, []);

const dateInputfrom = "dateInputfrom";
const dateInputto = "dateInputto";

const navigate = useNavigate();
const logout= ()=>{
    localStorage.setItem('isLoggedIn', 'false');
    localStorage.removeItem('AccountID');  
    localStorage.removeItem('isAdmin');
    navigate('/');
}

const nothingfunction=(orderid,oldValue, newValue)=>{
      setvehfilterval(newValue); 
}

return (
    <div> 
        <SimpleModal 
            isShowing={isOpen} 
            onClose={closeModal}  
            children={<div><h2 className='modal-title'>Please insert your vehicle</h2><input id="modalvehicle" className="modal-input"></input><div><Button className="modal-save-button" onClick={savevehicle}>Confirm</Button></div></div>}
        ></SimpleModal>

        <div className='row'   align='right'> 
            <div className='logout-buttondiv'>
                <button onClick={logout} className="logout-button">
                    <i className="fas fa-sign-out-alt"></i> LogOut
                </button>
            </div> 
        </div>

        <div class="toggle-menu">
            <button id="searchbydate" class="menuitem menuitem_active" onClick={datesearch}>Search by date</button>
            <button id="searchbyordernum" class="menuitem" onClick={ordernumsearch}>Search by OrderNum</button>
        </div>
  
        {isDateSearch && (
        <div className="date-filter-container">
    
            <div className="date-group">
                <label htmlFor={dateInputfrom} className="header-label">
                    Date From
                </label>
                <DatePicker
                className='datepick'
                id={dateInputfrom}
                selected={selectedDatefrom}
                onChange={(date) => {setSelectedDateFrom(date); setdatetodate(date);}}
                dateFormat="dd/MM/yyyy"
                />
                
            </div>
            
            <div className="date-group">
                <label htmlFor={dateInputto} className="header-label">
                    Date To
                </label>
                <DatePicker
                className='datepick'
                id={dateInputto}
                selected={selectedDateto}
                onChange={(date) => { if (date >= selectedDatefrom) {setSelectedDateTo(date);} }}
                dateFormat="dd/MM/yyyy"
                />
            </div>
             
            <div className="date-group">
                <label   className="header-label">
                    Vehicle
                </label>
               <SearchableVehicleSelect 
                      vehicleData={vehicleData}
                      apifunction={nothingfunction}
                      orderId={-1}
                      autoFocus={false} 
                      removeidontsee={true}
                    />
            </div>

            <div className="date-group">
                <label   className="header-label">
                    Flight
                </label>
                <input  Id="flightselectid"></input>
            </div>

            <button className="go-button" onClick={goclicked}>GO</button>
        </div>
        )}

        {!isDateSearch && (
            <div className="date-filter-container">
                <label   className="header-label">
                    Order Num
                </label>
                <input  Id="ordernumfilter"></input>
                <button className="go-button" onClick={goclicked}>GO</button>
            </div>
        )}

        {isLoading && (
            <p style={{ color: 'blue', fontWeight: 'bold' }}>
                <span role="img" aria-label="loading">⏳</span> Retrieving data from Server...
            </p>
        )}
        {!isLoading && (
        <div className="responsive-container">
            {isMobile ? (
                <div className="policy-card-list">
                        {rowData.map((route, index) => (
                        <MobileGrid vehicleData={vehicleData} vehiclechanged={vehiclechanged} Card key={index} route={route} />
                    ))}
                </div>
            ) : ( 
                <DataGrid rowData={rowData} vehicleData={vehicleData} vehiclechanged={vehiclechanged} ></DataGrid>
            )}
        </div>
        )}
    </div>
    
);
};

export default ResultPage;
 